import { render, staticRenderFns } from "./perAcco.vue?vue&type=template&id=d979e020&scoped=true&"
import script from "./perAcco.vue?vue&type=script&lang=js&"
export * from "./perAcco.vue?vue&type=script&lang=js&"
import style0 from "./perAcco.vue?vue&type=style&index=0&id=d979e020&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d979e020",
  null
  
)

export default component.exports